export const LobbyTypes = Object.freeze({
    ENDORSE: 'endorse',
    OPPOSE: 'oppose',
    NONE: 'none',
});